import React from "react"
import PropTypes from "prop-types"

import IconLinkedIn from "./linkedin"
import IconFacebook from "./facebook"
import IconYoutube from "./youtube"
import IconTwitter from "./twitter"

// Utility function to grab Icons by name
const Icon = ({ name, color }) => {
  switch (name.toLowerCase()) {
    case "facebook":
      return <IconFacebook color={color} />
    case "linkedin":
      return <IconLinkedIn color={color} />
    case "twitter":
      return <IconTwitter color={color} />
    case "youtube":
      return <IconYoutube color={color} />
    default:
      return null
  }
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
}

export default Icon
